import escapeHtml from 'escape-html';
import { Descendant, Text } from 'slate';
import { ElementTypes } from 'src/types/CustomSlateTypes';

const hash = require('hash-sum');

const serializeNodeToHtml: (node: Descendant) => string = (node) => {
  if (Text.isText(node)) {
    let string = escapeHtml(node.text);
    if (node.bold) {
      string = `<strong>${string}</strong>`;
    }
    if (node.italic) {
      string = `<em>${string}</em>`;
    }
    if (node.underline) {
      string = `<u>${string}</u>`;
    }
    if (node.strikethrough) {
      string = `<s>${string}</s>`;
    }
    return string;
  }

  const children = node.children.map((n) => serializeNodeToHtml(n)).join('');
  switch (node.type) {
    case ElementTypes.bulletedList:
      return `<ul>${children}</ul>`;
    case ElementTypes.numberedList:
      return `<ol>${children}</ol>`;
    case ElementTypes.listItem:
      return `<li>${children}</li>`;
    case ElementTypes.link:
      return `<a href="${node.url}" target="_blank">${children}</a>`;
    case ElementTypes.mention:
      return `<forums-mention id="${hash(node.userId)}"></forums-mention>`;
    case ElementTypes.image:
      return `<img src="${node.url}">`;
    case ElementTypes.quote:
      return `<forums-quote id="${node.quoteId}"></forums-quote>`;
    case ElementTypes.paragraph:
    default:
      return `<p>${children}</p>`;
  }
};

const serializeToHtml = (nodes: Descendant[]) => nodes.map((n) => serializeNodeToHtml(n)).join('');

export default serializeToHtml;
